import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Serial.css';
import * as actions from '../../../actions/serial';
import history from '../../../core/history'
import Layout from '../../../components/global/Layout';
import LoadMore from '../../../components/common/LoadMore';
import CourseCard from '../../../components/common/CourseCard'
import FilterCourse from '../../../components/p_serial/filterCourse'
import { trackEventLog } from '../../../core/utils';

const rlogSerialDtShow = (id, idx, pageFrom) => {
  const addtion = { unit: 'courseGroupList', type: pageFrom, position: idx + 1, courseId: id };
  trackEventLog('xue_show', addtion)
}

const rlogSerialDtClick = (id, idx, pageFrom) => {
  const addtion = { unit: 'courseGroupList', type: pageFrom, position: idx + 1, courseId: id };
  trackEventLog('xue_click', addtion)
}

class Serial extends React.Component {
  constructor(props) {
    super(props);
    this.loadSerialMore = this.loadSerialMore.bind(this);
    this.filterCourseHandle = this.filterCourseHandle.bind(this);
    this.state = {
      queryMap: {},
    }
  }

  componentDidMount() {
    const { serial } = this.props
    if (!serial.serialInfo.title) {
      history.replace('/not-found')
    }
  }

  loadSerialMore() {
    const { serial, serialCourseFetch } = this.props;
    const { courses, serialInfo } = serial || {};
    return serialCourseFetch(serialInfo.id, courses[courses.length - 1].rank, this.state.queryMap)
  }
  filterCourseHandle(queryMap) {
    this.state.queryMap = queryMap
    const { serial, serialCourseFetch } = this.props;
    const { serialInfo } = serial || {};
    return serialCourseFetch(serialInfo.id, 0, this.state.queryMap)
  }
  render() {
    const { serial } = this.props;
    const { courses, hasMore, serialInfo } = serial || {};
    const { filters, useFilter, hideNum, saleNum } = serialInfo
    const { query } = this.context || {};
    const { inLoc } = query || {};
    return (
      <Layout>
        <div className={s.content}>
          <h3 className={s.title}>
            { serialInfo.title }
            { !hideNum && !!saleNum &&
              <p>已有<span>{saleNum}人</span>购买</p>
            }
          </h3>
          { useFilter && filters &&
            <FilterCourse
              filters={filters}
              filterCourseHandle={this.filterCourseHandle}
            />
          }
          <div>
            { courses && courses.map((course, idx) => (
              <CourseCard
                key={`serial-course-${idx}`}
                data={course}
                onClick={() => rlogSerialDtClick(course.id, idx, inLoc)}
                showLogFuc={() => rlogSerialDtShow(course.id, idx, inLoc)}
                inLoc={inLoc === 'home' ? `fp_courseGroup_${course.id}` : `vp_courseGroup_${course.id}`}
              />
          ))}
            { courses && courses.length !== 0 ?
              <LoadMore onReachBottom={this.loadSerialMore} hasMore={hasMore} /> : null}
          </div>
        </div>
      </Layout>
    )
  }
}

Serial.propTypes = {
  serial: PropTypes.shape({
    courses: PropTypes.array,
    serialInfo: PropTypes.object,
    hasMore: PropTypes.bool,
  }).isRequired,
  serialCourseFetch: PropTypes.func.isRequired,
};

Serial.contextTypes = {
  query: PropTypes.object,
}

function mapStateToProps(state) {
  return {
    serial: state.serial,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(s)(Serial))




// WEBPACK FOOTER //
// ./src/routes/serial/serial/Serial.js